import ViewController from "core/views/view.controller";

export default class BookingStateSelectionCtrl extends ViewController {
    static $inject = ['$scope'];

    constructor() {
        super(...arguments);
        this.states = ['open', 'finished', 'cancelled'];

        // Bindings
        this.selectedState = null;
        this.onStateSelected = null;
    }

    selectState(state) {
        if (this.onStateSelected instanceof Function) {
            this.onStateSelected({state: state});
        }
    };

}



// WEBPACK FOOTER //
// ./src/modules/main/components/booking-state-selection/booking-state-selection.controller.js